const defaultState = () => {
  return {
    myPeer: {
      id: null,
      displayName: '',
      raisedHandsState: false,
      micState: false,
      webcamState: false,
      videoStream: null
    },
    peers: {},
    activeSpeakerPeerId: null,
    screenSharerPeerId: null,
    carousel: {
      prev: false,
      next: false,
      current: 1,
      perPage: 0,
      pages: 1,
      count: 1
    },
    perPages: {}
  }
}

const state = defaultState()

const getters = {
  myPeer: state => state.myPeer,
  peers: state => state.peers,
  activeSpeakerPeerId: state => state.activeSpeakerPeerId,
  screenSharerPeerId: state => state.screenSharerPeerId,
  carousel: state => state.carousel,
  perPages: state => state.perPages,
  sortedPeerIds: state => {
    return Object.entries(state.peers).filter(peerEntry => {
      return peerEntry[0] != state.screenSharerPeerId
    }).sort((current, next) => {
      return next[1].sortedAt - current[1].sortedAt
    }).map(peerEntry => peerEntry[0])
  },
  peerIdsByPage: (state, getters) => (page) => {
    const minIndex = state.carousel.perPage * page - state.carousel.perPage - (page == 1 || state.screenSharerPeerId == state.myPeer.id ? 0 : 1)
    const maxIndex = state.carousel.perPage * page - (state.screenSharerPeerId == state.myPeer.id ? 1 : 2)
    return getters.sortedPeerIds.filter((_, index) => {
      return minIndex <= index && index <= maxIndex
    })
  },
  frontPeerIds: (state, getters) => {
    return getters.peerIdsByPage(state.carousel.current)
  },
  backPeerIds: (state, getters) => {
    return Object.keys(state.peers).filter((peerId) => {
      return !getters.frontPeerIds.includes(peerId)
    })
  },
  raisedHandsPeersCount: (state) => {
    return Object.entries(state.peers).filter(peerEntry => {
      return peerEntry[1].raisedHandsState
    }).length
  }
}

const mutations = {
  myPeer(state, payload) {
    state.myPeer = { ...state.myPeer, ...payload }
  },
  peers(state, payload) {
    state.peers = { ...state.peers, ...payload }
  },
  removePeer(state, peerId) {
    const tmpPeers = { ...state.peers }
    delete tmpPeers[peerId]
    state.peers = tmpPeers
  },
  activeSpeakerPeerId(state, { peerId, getters, rootGetters }) {
    state.activeSpeakerPeerId = peerId
    if (
      !peerId ||
      rootGetters['auth/signedInUser'].id == peerId ||
      getters.peerIdsByPage(1).includes(peerId)
    ) return
    const activeSpeakerPeer = state.peers[peerId]
    if (activeSpeakerPeer) {
      activeSpeakerPeer.sortedAt = new Date()
      state.peers = { ...state.peers, ...{ [peerId]: activeSpeakerPeer } }
    }
  },
  raisedHandsStateOfPeer(state, { payload, getters }) {
    const { peerId, raisedHandsState } = payload
    const peer = state.peers[peerId]
    if (peer) {
      if (!getters.peerIdsByPage(1).includes(peerId) && raisedHandsState) {
        peer.sortedAt = new Date()
      }
      peer.raisedHandsState = raisedHandsState
      state.peers = { ...state.peers, ...{ [peerId]: peer } }
    }
  },
  screenSharerPeerId(state, payload) {
    state.screenSharerPeerId = payload
  },
  perPages(state, payload) {
    if (payload) {
      state.perPages = {
        all: 2,
        harf: 0,
        screenSharing: 0,
        none: 0
        }
    } else {
      state.perPages = {
        all: 8,
        harf: 4,
        screenSharing: 3,
        none: 0
      }
    }
    state.carousel.perPage = state.perPages.all
  },
  carousel(state, { to, nextPerPage } = {}) {
    const perPage = nextPerPage ?? state.carousel.perPage
    let count = Object.keys(state.peers).length
    if (perPage !== state.perPages.screenSharing) count++
    const pages = Math.ceil(count / perPage) || 1
    let current = to || state.carousel.current
    if (current > pages) current = pages
    state.carousel = {
      prev: current > 1,
      next: current != pages,
      current: current,
      perPage: perPage,
      pages: pages,
      count: count
    }
  },
  resetModule(state) {
    Object.assign(state, defaultState())
  }
}

const actions = {
  setMyPeer({ commit }, payload) {
    commit('myPeer', payload)
  },
  setPeer({ commit }, payload) {
    commit('peers', payload)
    commit('carousel')
  },
  removePeer({ commit }, peerId) {
    commit('removePeer', peerId)
    commit('carousel')
  },
  setActiveSpeakerPeerId({ commit, getters, rootGetters }, peerId) {
    commit('activeSpeakerPeerId', { peerId, getters, rootGetters })
  },
  setRaisedHandsStateOfPeer({ commit, getters }, payload) {
    commit('raisedHandsStateOfPeer', { payload, getters })
  },
  setScreenSharerPeerId({ commit }, peerId) {
    commit('screenSharerPeerId', peerId)
  },
  setPerPages({ commit }, payload) {
    commit('perPages', payload)
  },
  changeCarousel({ commit }, to) {
    commit('carousel', { to: to })
  },
  changePerPage({ commit }, perPageParam) {
    const perPage = state.perPages[perPageParam]
    commit('carousel', { nextPerPage: perPage })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
